module.exports = __webpack_public_path__ + "static/media/bg-start.6b98ada1.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/bg-start.png
// module id = 741
// module chunks = 0